import { get } from "@/util/requestUtils"

export function countMemberPoint(success) {
  return get("/point/public-api/member/point", {}, success)
}

export function getRecordList(params, success) {
  return get("/point/auth-api/record/list", params, success)
}
